import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import MDBox from "~/components/MDBox";
import MDTypography from "~/components/MDTypography";

const PublicFooter = () => {
  return (
    <MDBox
      mx={2}
      mt={-3}
      py={0.5}
      px={2}
      variant="gradient"
      bgColor="success"
      borderRadius="lg"
      coloredShadow="success"
      color="white"
    >
      <Grid container columnGap={2}>
        <Grid item xs={12} md={2.5}>
          PlantWatch Pro ©
          <script>document.write(/\d{4}/.exec(Date())[0])</script> | All rights
          reserved.
        </Grid>
        <Grid item xs={5} md={2.5}>
          <MDTypography
            variant="subtitle"
            component={Link}
            to="/privacy-policy"
          >
            Privacy Policy
          </MDTypography>
        </Grid>
        <Grid item xs={6} md={2.5}>
          <MDTypography variant="subtitle" component={Link} to="/eula">
            End User License Agreement{" "}
          </MDTypography>
        </Grid>
        <Grid item xs={6} md={2.5}>
          <MDTypography
            variant="subtitle"
            component={Link}
            to="/terms-condition"
          >
            Term and Condition{" "}
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default PublicFooter;
